import { IAnsweredSurvey } from '../common/data/dtos/answered-survey';
import { IAnsweredSurveyEmployee, IAnsweredSurveyReport } from '../common/data/dtos/answered-survey-employee';
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from '../helpers/httpHelper';

const BASE_PATH = 'api/AnsweredSurvey';

interface AnsweredSurveyResponse {
    success: boolean;
    answeredSurvey?: IAnsweredSurvey;
    answeredSurveys?: IAnsweredSurvey[];
    error?: string;
}

interface AnsweredSurveyEmployeeResponse {
    success: boolean;
    answeredSurveyEmployee?: IAnsweredSurveyEmployee;
    error?: string;
}

interface AnsweredSurveyReportResponse {
    success: boolean;
    answeredSurveyReport?: IAnsweredSurveyReport;
    error?: string;
}

type CreateAnsweredSurveyType = Omit<IAnsweredSurvey, 'id'> | Partial<IAnsweredSurvey>;

const createAnsweredSurvey = async (survey: CreateAnsweredSurveyType): Promise<AnsweredSurveyResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IAnsweredSurvey>(`${BASE_PATH}`, survey);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteAnsweredSurvey = async (id: string): Promise<AnsweredSurveyResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IAnsweredSurvey>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getAnsweredSurveys = async (): Promise<AnsweredSurveyResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IAnsweredSurvey>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, answeredSurveys: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneAnsweredSurvey = async (id: string): Promise<AnsweredSurveyEmployeeResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IAnsweredSurveyEmployee>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, answeredSurveyEmployee: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateAnsweredSurvey = async (answeredSurvey: IAnsweredSurvey): Promise<AnsweredSurveyResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<IAnsweredSurvey>(`${BASE_PATH}/${answeredSurvey.id}`, answeredSurvey);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getAnsweredSurveyReport = async (id: string): Promise<AnsweredSurveyReportResponse> => {
        try {
        const response = await GET_TYPED_ASYNC<IAnsweredSurveyReport>(`${BASE_PATH}/GetAnsweredSurveyReport?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, answeredSurveyReport: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createAnsweredSurvey,
    deleteAnsweredSurvey,
    getAnsweredSurveys,
    getOneAnsweredSurvey,
    updateAnsweredSurvey,
    getAnsweredSurveyReport
};
